export class IQuestion{
    constructor(
        public QuestionID?: any[],
        public Question?: any[]) {}
}